import { Component } from '@angular/core';

@Component({
  selector: 'apex-delete-checklist-dialog',
  templateUrl: './delete-dialog.component.html',
})
export class DeleteChecklistDialogComponent {
  completeAndArchiveCheck = false;
}
